import React from "react";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { FaCheckCircle, FaRocket } from "react-icons/fa";

const planNames: Record<string, string> = {
  small: "Small Plan (4–50 beds)",
  medium: "Medium Plan (51–80 beds)",
  "large-medium": "Large-Medium Plan (81–125 beds)",
  large: "Large Plan (126+ beds)",
};

const Onboarding: React.FC = () => {
  const location = useLocation();
  const state = (location.state as any) || {};
  const { plan, maintenance, support, total, firstName, lastName, facility, location: userLocation } = state;

  return (
    <motion.section initial={{ opacity: 0, y: 40 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, type: "spring" }} className="max-w-xl mx-auto py-12 px-4 text-center">
      <motion.div initial={{ scale: 0.8, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ delay: 0.1, type: "spring" }} className="bg-gradient-to-r from-green-100 to-blue-50 rounded-3xl shadow-lg p-8 mb-8 flex flex-col items-center">
        <FaCheckCircle className="text-green-500 text-5xl mb-4 animate-bounce" />
        <h1 className="text-3xl font-extrabold text-blue-800 mb-2">Welcome, {firstName}!</h1>
        <p className="text-lg text-blue-700 mb-4">Your 14-day free trial is active.</p>
        <div className="bg-white rounded-xl shadow px-6 py-3 text-blue-900 font-bold text-xl mb-2 border-2 border-blue-200 inline-block">
          {planNames[plan] || planNames.small}
        </div>
        <div className="text-gray-700 mb-2">Facility: <span className="font-semibold">{facility}</span></div>
        <div className="text-gray-700 mb-2">Location: <span className="font-semibold">{userLocation}</span></div>
        <div className="text-gray-700 mb-2">Add-ons: {maintenance ? "Maintenance" : ""}{maintenance && support ? ", " : ""}{support ? "Support" : ""}{!maintenance && !support ? "None" : ""}</div>
        <div className="text-blue-700 font-bold mt-2">After your 14-day trial, your card will be charged <span className="text-blue-900">${total}/mo</span></div>
      </motion.div>
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.3 }} className="bg-white rounded-2xl shadow p-8 mb-8">
        <h2 className="text-2xl font-bold text-blue-800 mb-2 flex items-center justify-center gap-2"><FaRocket /> Next Steps</h2>
        <ul className="list-disc list-inside text-left text-gray-700 mb-4">
          <li>Full access to templates library.</li>
          <li>Invite up to two managers to evaluate.</li>
          <li>Create rooms, assign templates, and run rounds.</li>
          <li>Try maintenance and ticketing workflows.</li>
        </ul>
        <div className="text-blue-700 font-semibold">Need help? <a href="/contact" className="underline">Contact our support team</a>.</div>
      </motion.div>
      <a href="/resources" className="text-blue-600 hover:underline">← Back to Resources</a>
    </motion.section>
  );
};

export default Onboarding;
